import config from '@/config';
import useCache from '@/hooks/useCache';
import useNavigateToArtwork from '@/hooks/useNavigateToArtwork';
import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableArtworkGridItems } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function LikedArtworks() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, loadMoreData } = useCache("liked_artworks", `${config.apis.api.url}/liked/artworks`, {
    injectToken: true,
    invalidateWhen: ["LIKE_ARTWORK"]
  });
  const safeFetchData = fetchData ?? { data: [], totalDocs: 0 };
  const visibleArtworks = filterRenderableArtworkGridItems(safeFetchData.data);
  const visiblePage = { ...safeFetchData, data: visibleArtworks, totalDocs: visibleArtworks.length };
  const activityTitle = t('menu.liked_artworks');
  const navigateToArtwork = useNavigateToArtwork(
    "liked_artworks",
    visiblePage,
    "/liked/artworks?",
    { type: 'activity-menu', label: activityTitle }
  );
  
  return (
    <>
      <ActivityHeading text={activityTitle}/>
      <div className="activity-liked-artworks__container">
        {
          loading ? 
            <Loader />
            : visibleArtworks.length === 0 ? 
              <Text className="activity-liked-artworks__text font-size-medium">
                {t('empty.liked_artworks')}
              </Text>
              :
              <VirtualList 
                items={safeFetchData}
                visibleItems={visibleArtworks}
                onLoadMore={loadMoreData}
                navigateToArtwork={navigateToArtwork}
              />
        }
      </div>
    </>
  );
}
